import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Dropdown from 'atoms/Dropdown'
import SubmenuLink from 'atoms/SubmenuLink'
import Accordion from 'molecules/Accordion'

const AccordionBody = styled.div`
    padding: 12px;
    background: #f6f6f6;
    border-bottom: 1px solid #e2e2e2;
`

const SubmenuWrapper = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    color: #384047;
    font-size: 14px;
    line-height: 21px;

    ${props => props.underlineLink && `
        &:before {
            content: '';
            display: block;
            position: absolute;
            width: 40px;
            height: 4px;
            left: 28px;
            top: -5px;
            background-color: #3CA4BE;
        }
    `}

    > li {
        border-bottom: 1px solid #E2E2E2;
    }

    > li:last-child {
        border: none;
    }

    > li:hover {
        color: #eee;
    }
`

const DropdownLabel = styled.span`
    list-style-type: none;
    padding: 0;
    margin: 0;
`

class Submenu extends Component {
  render () {
    const { children, items, underlineLink, topper, openOnClick, onSiteLink } = this.props
    if (items === undefined) {
      return null
    }
    return (
      <Dropdown
        label={
          <DropdownLabel underlineLink={underlineLink}>
            {children}
          </DropdownLabel>
        }
        openOnClick={openOnClick}
      >
        <SubmenuWrapper>
          {
            topper &&
                    topper
          }
          {
            items.map((item, index) => {
              if (item.subItems === undefined) {
                return (
                  <SubmenuLink
                    key={`Submenu-Link-${item.text.replace(' ', '-')}-${index}`}
                    item={item}
                    onSiteLink={onSiteLink}
                  />
                )
              }
              return (
                <Accordion
                  key={`Submenu-${index}`}
                  trigger={<SubmenuLink item={item} />}
                  caretPosition="middle"
                >
                  <AccordionBody>
                    {
                      item.subItems.map((subItem, subItemIndex) => {
                        return <SubmenuLink key={`Submenu-SubItem-${index}-${subItemIndex}`} item={subItem} />
                      })
                    }
                  </AccordionBody>
                </Accordion>
              )
            })
          }
        </SubmenuWrapper>

      </Dropdown>

    )
  }
}

Submenu.propTypes = {
  children: PropTypes.node.isRequired,
  items: PropTypes.array.isRequired,
  underlineLink: PropTypes.bool,
  topper: PropTypes.element,
  openOnClick: PropTypes.bool,
  onSiteLink: PropTypes.bool,
}

export default Submenu



// WEBPACK FOOTER //
// ./src/molecules/Submenu.js